// @flow
import { VERTICAL_NAMES } from '../common/constants/common';
import type { VerticalName } from '../common/types/verticalNames';

export function getAdItemTypeByVerticalName(verticalName: VerticalName): string | null {
  switch (verticalName) {
    case VERTICAL_NAMES.homes:
      return 'http://schema.org/SingleFamilyResidence https://schema.org/Offer';
    case VERTICAL_NAMES.cars:
      return 'http://schema.org/Car https://schema.org/Offer';
    case VERTICAL_NAMES.jobs:
      return 'http://schema.org/JobPosting';
    case VERTICAL_NAMES.products:
      return 'https://schema.org/Offer';
    default:
      return null;
  }
}

export function getLocationItemByVerticalName(
  verticalName: VerticalName
): { itemProp?: string, itemType?: string } {
  switch (verticalName) {
    case VERTICAL_NAMES.cars:
      return {
        itemProp: 'areaServed',
        itemType: 'http://schema.org/Place',
      };
    case VERTICAL_NAMES.jobs:
      return {
        itemProp: 'jobLocation',
        itemType: 'http://schema.org/Place',
      };
    default:
      return {};
  }
}



// WEBPACK FOOTER //
// ./app/utils/schemaOrg.js